<template>
  <div class="bg-white shadow-md rounded-lg p-4 w-full h-full">
    <div class="text-center">
      <button
        :class="[
          'bg-lightBlue-200 hover:bg-blue-700 text-blue-900 font-bold py-2 px-4 rounded w-full',
          extraClasses,
          disabled ? 'opacity-50 cursor-not-allowed' : '',
        ]"
        :disabled="disabled"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nameTitle: { type: String, required: true },
    buttonText: { type: String, required: true },
    jobTitle: { type: String, required: false },
    school: { type: String, required: false },
    content: String,
    content_type: String,
    disposition: String,
    extraClasses: { type: [String, Object, Array], default: "" }, // <-- NEW
    disabled: { type: Boolean, default: false },
  },
};
</script>
